import {
  ADMIN_CUSTOMER_LIST_REQUEST,
  ADMIN_CUSTOMER_LIST_SUCCESS,
  ADMIN_CUSTOMER_LIST_FAIL,
  DELETE_CUSTOMER_FAIL,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  CUSTOMER_SEARCH_FAIL,
  CUSTOMER_SEARCH_REQUEST,
  CUSTOMER_SEARCH_SUCCESS,
} from "./customerTypes";

export const customerListReducer = (state = {}, action) => {
  switch (action.type) {
    // REQUEST
    case ADMIN_CUSTOMER_LIST_REQUEST:
      return { ...state, loading: true, error: false };

    // LIST
    case ADMIN_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        customers: action.payload.customers,
        totalCustomerCount: action.payload.totalCustomerCount,
      };

    // FAILED
    case ADMIN_CUSTOMER_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_CUSTOMER_REQUEST:
      return { ...state, loading: true };

    case GET_CUSTOMER_SUCCESS:
      return { ...state, loading: false, customer: action.payload };

    case GET_CUSTOMER_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CUSTOMER_SEARCH_REQUEST:
      return { ...state, loading: true };

    case CUSTOMER_SEARCH_SUCCESS:
      return { ...state, loading: false, customerResult: action.payload };

    case "CUSTOMER_SEARCH_RESET":
      return { ...state, loading: false, customerResult: [] };

    case CUSTOMER_SEARCH_FAIL:
      return { ...state, loading: false, error: action.payload };

    case DELETE_CUSTOMER_REQUEST:
      return { ...state, loading: true, success: false };

    case DELETE_CUSTOMER_SUCCESS:
      return { ...state, loading: false, success: true };

    case DELETE_CUSTOMER_FAIL:
      return { ...state, loading: false };

    case UPDATE_CUSTOMER_REQUEST:
      return { ...state, loading: true, updated: false };

    case UPDATE_CUSTOMER_SUCCESS:
      return { ...state, loading: false, updated: true };

    case UPDATE_CUSTOMER_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
};
